import { addProp } from "@pnp/odata";
import { _List } from "../lists/types.js";
import { Views, View } from "./types.js";
addProp(_List, "views", Views);
addProp(_List, "defaultView", View, "DefaultView");
_List.prototype.getView = function (viewId) {
    return View(this, "getView('" + viewId + "')");
};
//# sourceMappingURL=list.js.map